import type { ReactNode } from 'react';
import { HackleProvider } from '@hackler/react-sdk';
import {
  FeatherConfig,
  ToastContainer,
  ToastContextProvider,
} from '@kcd/design-system';

import { SnackbarProvider } from '~/components/Snackbar';
import { ReferrerProvider } from '~/hooks/useReferrer';
import { hackleClient } from '~/libs/hackle';

export const ProviderWrap = ({ children }: { children: ReactNode }) => {
  return (
    <HackleProvider hackleClient={hackleClient}>
      <FeatherConfig>
        <ReferrerProvider>
          <ToastContextProvider>
            <SnackbarProvider
              containerProps={{
                portalTargetSelecter: '#snackbar',
              }}
            >
              {children}
              <ToastContainer
                style={{ zIndex: 20 }}
                portalTargetSelector="#toast"
              />
            </SnackbarProvider>
          </ToastContextProvider>
        </ReferrerProvider>
      </FeatherConfig>
    </HackleProvider>
  );
};
